import React, { useState, useEffect, useRef } from 'react';
import { 
  FaArrowLeft, 
  FaCheckCircle, 
  FaUser, 
  FaTimes, 
  FaUserShield, 
  FaWallet, 
  FaBitcoin, 
  FaEthereum, 
  FaChartLine, 
  FaExchangeAlt, 
  FaWhatsapp,
  FaTelegram,
  FaHistory, 
  FaLock, 
  FaShieldAlt, 
  FaHeadset, 
  FaInfoCircle, 
  FaBell,
  FaUsers,
  FaDollarSign,
  FaDatabase,
  FaGlobe,
} from 'react-icons/fa';
import { SiRipple, SiLitecoin, SiDogecoin, SiTether } from 'react-icons/si';
import { IoWallet, IoSwapVertical, IoTrendingUp, IoTrendingDown } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import BottomNavigation from './BottomNavigation';
import LiveTransactionsBot from './LiveTransactionsBot';
import { useAuth } from '../security/security/AuthContext';
import axios from 'axios';
import CashoutView from './CashoutView';
import DepositRecord from './DepositRecord';
import WithdrawalRecord from './WithdrawalRecord';
import TaskView from './TaskView';
import HotProductSection from './HotProductSection';

// Import recharts components for the trading chart
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
  ReferenceLine
} from 'recharts';

const Home = () => {
  // State from original component
  const [selectedNav, setSelectedNav] = useState('home');
  const [showPopup, setShowPopup] = useState(true);
  const [currentView, setCurrentView] = useState('main');
  const [depositAmount, setDepositAmount] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [openedGiftBoxes, setOpenedGiftBoxes] = useState([]);
  const [showInvestmentDialog, setShowInvestmentDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [products, setProducts] = useState([]);
  const [toastNotification, setToastNotification] = useState(null);
  const [investmentSuccess, setInvestmentSuccess] = useState(null);
  const { userDetails, token, updateUserDetails, isLoading, isSuperLogin, exitSuperLogin } = useAuth();

  // Payment processing states
  const [showPaymentLoader, setShowPaymentLoader] = useState(false);
  const [paymentLoaderMessage, setPaymentLoaderMessage] = useState('');
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [transactionCode, setTransactionCode] = useState('');
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isActivated, setIsActivated] = useState(false);
  const [hotProduct, setHotProduct] = useState(null);

  // New states for crypto-specific features
  const [selectedCrypto, setSelectedCrypto] = useState('BTC');
  const [cryptoPrices, setCryptoPrices] = useState({
    BTC: { price: 68432.15, change: 2.34 },
    ETH: { price: 3950.77, change: -1.23 },
    XRP: { price: 0.5324, change: 3.45 },
    LTC: { price: 82.42, change: 1.78 },
    DOGE: { price: 0.1234, change: 5.67 },
    USDT: { price: 1.00, change: 0.01 }
  });
  const [chartTimeframe, setChartTimeframe] = useState('1D');
  const [marketTrends, setMarketTrends] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, message: "BTC price alert: Up 2.34% in the last 24h", time: "10 mins ago", read: false },
    { id: 2, message: "Mining rewards are automatically credited to your wallet", time: "1 hour ago", read: false },
    { id: 3, message: "New mining device available: ETH Miner Pro", time: "3 hours ago", read: false }
  ]);
  
  const authContext = useAuth();

  // Style object for inline styling
  const styles = {
    container: {
      backgroundColor: '#0F172A',
      color: '#E2E8F0',
      minHeight: '100vh',
      fontFamily: 'Inter, system-ui, sans-serif',
      paddingBottom: '80px',
    },
    header: {
      background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
      padding: '16px',
      borderBottom: '1px solid #1E3A5F',
    },
    welcomeText: {
      fontSize: '20px',
      fontWeight: '600',
      margin: '0 0 4px 0',
      color: '#F8FAFC',
    },
    userInfoContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '12px',
    },
    userIcon: {
      backgroundColor: '#2563EB',
      color: 'white',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '12px',
    },
    userDetails: {
      flex: 1,
    },
    userName: {
      fontSize: '16px',
      fontWeight: '500',
      color: '#F8FAFC',
      margin: 0,
    },
    userMobile: {
      fontSize: '12px',
      color: '#94A3B8',
      margin: '4px 0 0 0',
    },
    walletCard: {
      background: 'linear-gradient(135deg, #1E3A5F 0%, #0C4A6E 100%)',
      borderRadius: '12px',
      padding: '16px',
      margin: '16px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
      position: 'relative',
      overflow: 'hidden',
    },
    walletHeader: {
      fontSize: '14px',
      color: '#94A3B8',
      marginBottom: '8px',
    },
    walletAmount: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '8px',
      color: '#F8FAFC',
    },
    currencySymbol: {
      fontSize: '16px',
      marginRight: '4px',
      opacity: 0.7,
    },
    walletActions: {
      display: 'flex',
      gap: '12px',
      marginTop: '12px',
    },
    actionButton: {
      backgroundColor: '#2563EB',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '10px 16px',
      fontSize: '14px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    cryptoSelector: {
      display: 'flex',
      overflowX: 'auto',
      margin: '16px',
      gap: '12px',
      paddingBottom: '8px',
    },
    cryptoOption: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '12px',
      minWidth: '90px',
      cursor: 'pointer',
      border: '1px solid #334155',
      transition: 'all 0.2s ease',
    },
    activeCryptoOption: {
      backgroundColor: '#0C4A6E',
      borderColor: '#38BDF8',
    },
    cryptoIcon: {
      fontSize: '24px',
      marginBottom: '8px',
    },
    cryptoName: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    cryptoPrice: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    cryptoChange: {
      fontSize: '12px',
      fontWeight: '500',
      marginTop: '4px',
    },
    positiveChange: {
      color: '#10B981',
    },
    negativeChange: {
      color: '#EF4444',
    },
    chartContainer: {
      margin: '0 16px 24px',
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '16px',
      border: '1px solid #334155',
    },
    chartHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
    },
    chartTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#F8FAFC',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    timeframeSelector: {
      display: 'flex',
      backgroundColor: '#0F172A',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    timeframeOption: {
      padding: '6px 12px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#94A3B8',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    activeTimeframeOption: {
      backgroundColor: '#2563EB',
      color: 'white',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '16px',
      margin: '16px',
    },
    featureItem: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      border: '1px solid #334155',
    },
    featureIcon: {
      fontSize: '24px',
      color: '#38BDF8',
      marginBottom: '8px',
    },
    featureLabel: {
      fontSize: '12px',
      color: '#F8FAFC',
      textAlign: 'center',
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      margin: '24px 16px 16px',
      color: '#E2E8F0',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    marketTrendsCard: {
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      margin: '0 16px 16px',
      border: '1px solid #334155',
      overflow: 'hidden',
    },
    marketTrendsList: {
      display: 'flex',
      flexDirection: 'column',
    },
    marketTrendItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
    },
    trendInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    trendIcon: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
    },
    trendDetails: {
      display: 'flex',
      flexDirection: 'column',
    },
    trendName: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    trendSymbol: {
      fontSize: '12px',
      color: '#94A3B8',
    },
    trendPrice: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    navItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px',
      borderBottom: '1px solid #334155',
      cursor: 'pointer',
    },
    navItemLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#F8FAFC',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 16px',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#E2E8F0',
      fontSize: '16px',
      cursor: 'pointer',
    },
    superLoginBanner: {
      backgroundColor: 'rgba(220, 38, 38, 0.9)',
      color: 'white',
      padding: '8px 16px',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    superLoginText: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      fontWeight: '500',
    },
    superLoginButton: {
      backgroundColor: 'white',
      color: '#DC2626',
      border: 'none',
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '12px',
      fontWeight: '500',
      cursor: 'pointer',
    },
    popup: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '16px',
    },
    popupContent: {
      backgroundColor: '#1E293B',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '400px',
      padding: '24px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
      border: '1px solid #2563EB',
    },
    popupTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#F8FAFC',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    popupText: {
      fontSize: '14px',
      color: '#E2E8F0',
      marginBottom: '16px',
      lineHeight: 1.5,
    },
    popupButtons: {
      display: 'flex',
      gap: '12px',
      marginTop: '24px',
    },
    popupButton: {
      flex: 1,
      padding: '12px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
    },
    telegramButton: {
      backgroundColor: '#0088cc',
      color: 'white',
    },
    closeButton: {
      backgroundColor: '#475569',
      color: 'white',
    },
    logoutButton: {
      backgroundColor: '#25D366',
      color: 'white',
      marginTop: '12px',
      width: '100%',
      padding: '12px',
      borderRadius: '8px',
      border: 'none',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    notificationBell: {
      position: 'relative',
      fontSize: '22px',
      color: '#F8FAFC',
      cursor: 'pointer',
    },
    notificationBadge: {
      position: 'absolute',
      top: '-5px',
      right: '-5px',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      backgroundColor: '#EF4444',
      color: 'white',
      fontSize: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    notificationsPanel: {
      position: 'absolute',
      top: '40px',
      right: '0',
      width: '300px',
      backgroundColor: '#1E293B',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
      border: '1px solid #334155',
      zIndex: 100,
    },
    notificationHeader: {
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
      fontSize: '14px',
      fontWeight: '600',
      color: '#F8FAFC',
    },
    notificationList: {
      maxHeight: '300px',
      overflowY: 'auto',
    },
    notificationItem: {
      padding: '12px 16px',
      borderBottom: '1px solid #334155',
      cursor: 'pointer',
    },
    notificationMessage: {
      fontSize: '13px',
      color: '#E2E8F0',
      marginBottom: '4px',
    },
    notificationTime: {
      fontSize: '11px',
      color: '#94A3B8',
    },
    unreadNotification: {
      backgroundColor: 'rgba(37, 99, 235, 0.1)',
    },
    chartPlaceholder: {
      height: '250px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#94A3B8',
      fontSize: '14px',
    },
    cryptoBadges: {
      display: 'flex',
      position: 'absolute',
      top: '12px',
      right: '12px',
    },
    cryptoBadge: {
      width: '24px',
      height: '24px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '14px',
      marginLeft: '-8px',
      border: '1px solid #0F172A',
    },
    toast: {
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#1E293B',
      color: 'white',
      padding: '12px 16px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      zIndex: 1001,
      width: '90%',
      maxWidth: '400px',
      border: '1px solid',
    },
    successToast: {
      borderColor: '#10B981',
    },
    errorToast: {
      borderColor: '#EF4444',
    }
  };

  // Generate chart data
  const generateChartData = (timeframe, crypto) => {
    const now = new Date();
    const data = [];
    let numPoints;
    let startValue;
    let volatility;
    
    switch(timeframe) {
      case '1H':
        numPoints = 60;
        startValue = cryptoPrices[crypto].price * 0.995;
        volatility = 0.001;
        break;
      case '1D':
        numPoints = 24;
        startValue = cryptoPrices[crypto].price * 0.97;
        volatility = 0.005;
        break;
      case '1W':
        numPoints = 7;
        startValue = cryptoPrices[crypto].price * 0.93;
        volatility = 0.01;
        break;
      case '1M':
        numPoints = 30;
        startValue = cryptoPrices[crypto].price * 0.85;
        volatility = 0.02;
        break;
      case '1Y':
        numPoints = 12;
        startValue = cryptoPrices[crypto].price * 0.7;
        volatility = 0.05;
        break;
      default:
        numPoints = 24;
        startValue = cryptoPrices[crypto].price * 0.97;
        volatility = 0.005;
    }
    
    let value = startValue;
    
    for (let i = 0; i < numPoints; i++) {
      const date = new Date(now);
      
      switch(timeframe) {
        case '1H':
          date.setMinutes(now.getMinutes() - (numPoints - i));
          break;
        case '1D':
          date.setHours(now.getHours() - (numPoints - i));
          break;
        case '1W':
          date.setDate(now.getDate() - (numPoints - i));
          break;
        case '1M':
          date.setDate(now.getDate() - (numPoints - i));
          break;
        case '1Y':
          date.setMonth(now.getMonth() - (numPoints - i));
          break;
        default:
          date.setHours(now.getHours() - (numPoints - i));
      }
      
      // Random walk with tendency to move up
      const change = (Math.random() - 0.45) * volatility * value;
      value += change;
      
      // Ensure the final point is the current price
      if (i === numPoints - 1) {
        value = cryptoPrices[crypto].price;
      }
      
      let timeLabel;
      switch(timeframe) {
        case '1H':
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          break;
        case '1D':
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          break;
        case '1W':
          timeLabel = date.toLocaleDateString([], { weekday: 'short' });
          break;
        case '1M':
          timeLabel = date.toLocaleDateString([], { day: 'numeric', month: 'short' });
          break;
        case '1Y':
          timeLabel = date.toLocaleDateString([], { month: 'short' });
          break;
        default:
          timeLabel = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
      
      data.push({
        time: timeLabel,
        price: value,
        date: date,
      });
    }
    
    return data;
  };

  // Generate market trends data
  const generateMarketTrends = () => {
    return [
      { id: 'BTC', name: 'Bitcoin', symbol: 'BTC/USD', price: cryptoPrices.BTC.price, change: cryptoPrices.BTC.change, icon: <FaBitcoin style={{color: '#F7931A'}} /> },
      { id: 'ETH', name: 'Ethereum', symbol: 'ETH/USD', price: cryptoPrices.ETH.price, change: cryptoPrices.ETH.change, icon: <FaEthereum style={{color: '#627EEA'}} /> },
      { id: 'XRP', name: 'Ripple', symbol: 'XRP/USD', price: cryptoPrices.XRP.price, change: cryptoPrices.XRP.change, icon: <SiRipple style={{color: '#0066B1'}} /> },
      { id: 'LTC', name: 'Litecoin', symbol: 'LTC/USD', price: cryptoPrices.LTC.price, change: cryptoPrices.LTC.change, icon: <SiLitecoin style={{color: '#B5B5B5'}} /> },
      { id: 'DOGE', name: 'Dogecoin', symbol: 'DOGE/USD', price: cryptoPrices.DOGE.price, change: cryptoPrices.DOGE.change, icon: <SiDogecoin style={{color: '#C3A634'}} /> },
    ];
  };

  useEffect(() => {
    if (!isLoading && userDetails?.mobile) {
      setPhoneNumber(userDetails.mobile);
    }
    if (!isLoading && userDetails?.email) {
      fetchAvailableProducts();
    }
    
    // Generate market trends data
    setMarketTrends(generateMarketTrends());
    
    // Simulate live price updates
    const interval = setInterval(() => {
      setCryptoPrices(prevPrices => {
        const newPrices = { ...prevPrices };
        Object.keys(newPrices).forEach(crypto => {
          const change = (Math.random() - 0.485) * 0.5;
          newPrices[crypto] = {
            price: Math.max(newPrices[crypto].price * (1 + change / 100), 0.01),
            change: Math.max(Math.min(newPrices[crypto].change + change, 10), -10)
          };
        });
        return newPrices;
      });
    }, 3000);
    
    return () => clearInterval(interval);
  }, [userDetails, isLoading]);

  const formatPhoneNumber = (number) => {
    if (number.startsWith('07') || number.startsWith('01')) {
      return '254' + number.slice(1);
    }
    return number;
  };

  const refreshUserData = async () => {
    try {
      const userResponse = await axios.get(`https://api.novasoftwaves.com/api/v1/auth/${userDetails.email}`, {
        headers: {
          'Authorization': token
        }
      });
      updateUserDetails(userResponse.data);
    } catch (error) {
      console.error('Error refreshing user data:', error);
      setToastNotification({ message: 'Failed to refresh user data', type: 'error' });
    }
  };

  const refreshProducts = async () => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/api/products/available/${userDetails.email}`);
      if (response.data && Array.isArray(response.data)) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error('Error refreshing products:', error);
    }
  };

  const refreshAllData = async () => {
    await Promise.all([
      refreshUserData(),
      refreshProducts()
    ]);
  };

  useEffect(() => {
    if (currentView === 'main') {
      refreshAllData();
    }
  }, [currentView]);

  const handlePaymentSuccess = async () => {
    await refreshAllData();
    setCurrentView('paymentSuccess');
  };

  const fetchAvailableProducts = async () => {
    try {
      const [productsResponse, hotProductsResponse] = await Promise.all([
        axios.get(`https://api.novasoftwaves.com/api/products/available/${userDetails.email}`),
        axios.get('https://api.novasoftwaves.com/api/products/hot')
      ]);
      
      if (productsResponse.data && Array.isArray(productsResponse.data)) {
        setProducts(productsResponse.data.filter(p => p.productType === 'NORMAL'));
      }
      
      if (hotProductsResponse.data && hotProductsResponse.data.length > 0) {
        setHotProduct(hotProductsResponse.data[0]);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
      setToastNotification({ message: 'Failed to fetch mining devices. Please try again.', type: 'error' });
    }
  };

  const handleInvest = (product) => {
    setSelectedProduct(product);
    setQuantity(1);
    setShowInvestmentDialog(true);
  };

  const handleCloseInvestmentDialog = () => {
    setShowInvestmentDialog(false);
    setSelectedProduct(null);
    setQuantity(1);
  };

  const handleQuantityChange = (newQuantity) => {
    setQuantity(newQuantity);
  };

  const calculateTotalBalance = () => {
    const wallet = Number(userDetails.wallet) || 0;
    const invitationIncome = Number(userDetails.invitationIncome) || 0;
    return (wallet + invitationIncome).toLocaleString();
  };

  const handleInvestNow = async () => {
    try {
      const response = await axios.post('https://api.novasoftwaves.com/api/investments/invest', null, {
        params: {
          userEmail: userDetails.email,
          productId: selectedProduct.id,
          quantity: quantity
        }
      });
      
      if (response.status === 200) {
        await refreshAllData();
        setShowInvestmentDialog(false);
        setInvestmentSuccess(response.data);
        setCurrentView('investmentSuccess');
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setToastNotification({ message: error.response.data, type: 'error' });
        setCurrentView('deposit');
        setDepositAmount((selectedProduct.price * quantity).toString());
      } else {
        console.error('Error making investment:', error);
        setToastNotification({ message: 'Transaction failed. Please try again!', type: 'error' });
      }
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    setShowPaymentLoader(true);
    setPaymentLoaderMessage('Please check your phone to complete payment.');

    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
    const requestData = {
      PhoneNumber: formattedPhoneNumber,
      Amount: parseInt(depositAmount),
    };

    try {
      await axios.post('https://api.novasoftwaves.com/mobile-money/stk-transaction-request', requestData, {
        headers: {
          'Authorization': token
        }
      });
      
      setTimeout(() => {
        setPaymentLoaderMessage('Processing transaction...');
      }, 20000);

      setTimeout(() => {
        checkPaymentStatus(formattedPhoneNumber);
      }, 27000);
    } catch (error) {
      console.error(error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to initiate payment. Please try again.', type: 'error' });
    }
  };

  const checkPaymentStatus = async (phoneNumber) => {
    try {
      const response = await axios.get(`https://api.novasoftwaves.com/mobile-money/transactions/check-payment/${phoneNumber}`, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.paymentFound) {
        await processTransaction(phoneNumber);
        setPaymentSuccess(true);
        setShowPaymentLoader(false);
        setToastNotification({ message: 'Payment successful!', type: 'success' });
        setCurrentView('paymentSuccess');
      } else {
        setShowPaymentLoader(false);
        setShowTransactionForm(true);
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setShowPaymentLoader(false);
      setToastNotification({ message: 'Failed to check payment status. Please try again.', type: 'error' });
    }
  };

  const processTransaction = async (phoneNumber) => {
    try {
      const response = await axios.post('https://api.novasoftwaves.com/mobile-money/users/activate', {
        phoneNumber: phoneNumber,
        email: userDetails.email
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (response.data.message) {
        setIsActivated(true);
        await refreshAllData();
      }
    } catch (error) {
      console.error('Error processing transaction:', error);
      throw error;
    }
  };

  const handleTransactionCodeSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPayment(true);
  
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
  
    try {
      const verifyResponse = await axios.post('https://api.novasoftwaves.com/mobile-money/transactions/verify', {
        phoneNumber: formattedPhoneNumber,
        transactionCode: transactionCode
      }, {
        headers: {
          'Authorization': token
        }
      });
  
      if (verifyResponse.data.verified) {
        await processTransaction(formattedPhoneNumber);
        await refreshAllData();
        setPaymentSuccess(true);
        setCurrentView('paymentSuccess');
        setToastNotification({ message: 'Payment verified successfully!', type: 'success' });
      } else {
        setToastNotification({ message: 'Invalid transaction code. Please try again.', type: 'error' });
      }
    } catch (error) {
      console.error('Error verifying transaction:', error);
      setToastNotification({ message: 'Failed to verify transaction. Please try again.', type: 'error' });
    } finally {
      setIsSubmittingPayment(false);
    }
  };

  const getCryptoIcon = (crypto) => {
    switch(crypto) {
      case 'BTC':
        return <FaBitcoin style={{color: '#F7931A'}} />;
      case 'ETH':
        return <FaEthereum style={{color: '#627EEA'}} />;
      case 'XRP':
        return <SiRipple style={{color: '#0066B1'}} />;
      case 'LTC':
        return <SiLitecoin style={{color: '#B5B5B5'}} />;
      case 'DOGE':
        return <SiDogecoin style={{color: '#C3A634'}} />;
      case 'USDT':
        return <SiTether style={{color: '#26A17B'}} />;
      default:
        return <FaBitcoin />;
    }
  };

  const joinTelegramChannel = () => {
    const telegramLink = "https://t.me/novasoftwaves";
    window.open(telegramLink, '_blank');
  };

  const joinWhatsAppChannel = () => {
    const telegramLink = "https://whatsapp.com/channel/0029Vb6YPaO3QxRsyi9Z3f2e";
    window.open(telegramLink, '_blank');
  };

  const whatsappservice = () => {
    const whatsappLink = "https://t.me/novasoftwavess";
    window.open(whatsappLink, '_blank');
  };

  const downloadApp = () => {
    setToastNotification({ message: 'Mobile App will be available Soon.', type: 'success' });
  };

  const logout = () => {
    authContext.logout();
  };

  const features = [
    { name: "Deposit", icon: <FaWallet style={styles.featureIcon} />, view: 'deposit' },
    { name: "Mining Packages", icon: <FaDatabase style={styles.featureIcon} />, view: 'mining' },
    { name: "My Deposits", icon: <FaChartLine style={styles.featureIcon} />, view: 'mydeposit' },
    { name: "Withdrawals", icon: <IoSwapVertical style={styles.featureIcon} />, view: 'withdrawal' },
    { name: "Support", icon: <FaHeadset style={styles.featureIcon} />, view: 'customer' },
    { name: "Company", icon: <FaGlobe style={styles.featureIcon} />, view: 'about' },
  ];

  // View renderers
  const renderInvestmentSuccessView = () => (
    <div style={{padding: '16px'}}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '24px'
      }}>
        <FaCheckCircle style={{
          fontSize: '64px',
          color: '#10B981',
          marginBottom: '16px'
        }} />
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '8px'
        }}>Mining Operation Started!</h2>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
        border: '1px solid #334155'
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '16px'
        }}>{investmentSuccess.productName}</h3>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Quantity</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>{quantity}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Investment Amount</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>KES {investmentSuccess.investedAmount.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Daily Yield</span>
          <span style={{color: '#10B981', fontWeight: '500'}}>KES {investmentSuccess.dailyIncome.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0',
          borderBottom: '1px solid #334155'
        }}>
          <span style={{color: '#94A3B8'}}>Total Expected Return</span>
          <span style={{color: '#10B981', fontWeight: '500'}}>KES {investmentSuccess.totalIncome.toLocaleString()}</span>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 0'
        }}>
          <span style={{color: '#94A3B8'}}>Mining Period Ends</span>
          <span style={{color: '#F8FAFC', fontWeight: '500'}}>{investmentSuccess.validUntil.split('T')[0]}</span>
        </div>
      </div>
      
      <div style={{
        backgroundColor: '#0F172A',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '24px',
        border: '1px solid #334155'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaInfoCircle style={{color: '#38BDF8'}} />
          How to Receive Mining Rewards
        </h3>
        
        <p style={{
          fontSize: '14px',
          color: '#94A3B8',
          marginBottom: '8px',
          lineHeight: 1.5
        }}>
          Your mining rewards will be added to your wallet every hour and can be collected from your Mining Dashboard.
        </p>
        
        <p style={{
          fontSize: '14px',
          color: '#94A3B8',
          lineHeight: 1.5
        }}>
          When the mining period ends, your initial investment will automatically return to your balance.
        </p>
      </div>
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}>
        <button 
          style={{
            backgroundColor: '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}
          onClick={() => window.location.href = '/order'}
        >
          <FaChartLine /> View Mining Dashboard
        </button>
        
        <button 
          style={{
            backgroundColor: 'transparent',
            color: '#94A3B8',
            border: '1px solid #334155',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer'
          }}
          onClick={() => setCurrentView('main')}
        >
          Back to Home
        </button>
      </div>
    </div>
  );

  const renderDepositRecord = () => (
    <div>
      <DepositRecord userDetails={userDetails} token={authContext.token} />
    </div>
  );

  const renderWithdrawalRecord = () => (
    <div>
      <WithdrawalRecord userDetails={userDetails} token={token} />
    </div>
  );

  const renderCustomerService = () => (
    <div style={{padding: '16px'}}>
      <h2 style={{
        fontSize: '20px',
        fontWeight: '600',
        color: '#F8FAFC',
        marginBottom: '24px'
      }}>Customer Support</h2>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        overflow: 'hidden',
        marginBottom: '16px',
        border: '1px solid #334155'
      }}>
        <div style={{
          padding: '16px',
          borderBottom: '1px solid #334155',
          fontSize: '16px',
          fontWeight: '600',
          color: '#F8FAFC'
        }}>
          Contact Methods
        </div>
        
        <div style={{padding: '16px'}}>
          <button 
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: '#25D366',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              marginBottom: '12px'
            }}
            onClick={whatsappservice}
          >
            <FaWhatsapp /> Contact Support
          </button>
          
          <button 
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: '#0088cc',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
            onClick={joinTelegramChannel}
          >
            <FaTelegram /> Telegram Channel
          </button>
        </div>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #334155'
      }}>
        <div style={{
          padding: '16px',
          borderBottom: '1px solid #334155',
          fontSize: '16px',
          fontWeight: '600',
          color: '#F8FAFC'
        }}>
          Support Hours
        </div>
        
        <div style={{padding: '16px'}}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            borderBottom: '1px solid #334155'
          }}>
            <span style={{color: '#94A3B8'}}>Monday - Friday</span>
            <span style={{color: '#F8FAFC'}}>8:00 AM - 8:00 PM</span>
          </div>
          
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            borderBottom: '1px solid #334155'
          }}>
            <span style={{color: '#94A3B8'}}>Saturday</span>
            <span style={{color: '#F8FAFC'}}>9:00 AM - 5:00 PM</span>
          </div>
          
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0'
          }}>
            <span style={{color: '#94A3B8'}}>Sunday</span>
            <span style={{color: '#F8FAFC'}}>Closed</span>
          </div>
        </div>
      </div>
    </div>
  );

  const   renderCashoutView = () => (
    <CashoutView 
      setCurrentView={setCurrentView}
      userDetails={userDetails}
      token={token}
      calculateTotalBalance={calculateTotalBalance}
      setToastNotification={setToastNotification}
    />
  );

  const renderTaskView = () => (
    <TaskView 
      userEmail={userDetails.email}
      onInvest={(gadget) => {
        setSelectedProduct(gadget);
        setQuantity(gadget.shares);
        setShowInvestmentDialog(true);
        setCurrentView('main');
      }}
    />
  );

  const renderAboutUs = () => (
    <div style={{padding: '16px'}}>
      <h1 style={{
        fontSize: '24px',
        fontWeight: '700',
        color: '#F8FAFC',
        marginBottom: '20px'
      }}>About CryptoNova</h1>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #334155'
      }}>
        <h2 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#38BDF8',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaGlobe /> Our Mission
        </h2>
        
        <p style={{
          fontSize: '14px',
          color: '#E2E8F0',
          marginBottom: '16px',
          lineHeight: 1.6
        }}>
          At CryptoNova, we're democratizing access to cryptocurrency mining and investment opportunities. Our mission is to provide a secure, user-friendly platform that allows everyone—from beginners to experts—to participate in the digital currency revolution.
        </p>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #334155'
      }}>
        <h2 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#38BDF8',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaChartLine /> Our Approach
        </h2>
        
        <p style={{
          fontSize: '14px',
          color: '#E2E8F0',
          marginBottom: '16px',
          lineHeight: 1.6
        }}>
          We believe that cryptocurrency mining should be accessible to everyone, not just those with technical expertise or substantial capital. That's why we've built a platform that handles the complexity of mining operations, allowing you to invest in mining hardware and earn rewards without managing the technical infrastructure yourself.
        </p>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #334155'
      }}>
        <h2 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#38BDF8',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaDatabase /> Mining Technology
        </h2>
        
        <p style={{
          fontSize: '14px',
          color: '#E2E8F0',
          marginBottom: '16px',
          lineHeight: 1.6
        }}>
          Our state-of-the-art mining facilities are equipped with the latest ASIC and GPU miners, optimized for maximum efficiency and profitability. We maintain operations across multiple cryptocurrencies, including Bitcoin, Ethereum, Litecoin, and more, diversifying mining activities to maximize returns for our users.
        </p>
      </div>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #334155'
      }}>
        <h2 style={{
          fontSize: '18px',
          fontWeight: '600',
          color: '#38BDF8',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaShieldAlt /> Security & Transparency
        </h2>
        
        <p style={{
          fontSize: '14px',
          color: '#E2E8F0',
          lineHeight: 1.6
        }}>
          Security is our top priority. We employ industry-leading security practices to protect your investments and personal information. Our transparent mining operations allow you to track your earnings in real-time, providing complete visibility into your investment performance.
        </p>
      </div>
    </div>
  );

  const renderPaymentProcessView = () => (
    <div style={{padding: '16px'}}>
      {!showPaymentLoader && !showTransactionForm && (
        <div>
          <h2 style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#F8FAFC',
            marginBottom: '24px'
          }}>
            Confirm Payment Details
          </h2>
          
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            border: '1px solid #334155'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '12px 0',
              borderBottom: '1px solid #334155'
            }}>
              <span style={{color: '#94A3B8'}}>Deposit Amount</span>
              <span style={{color: '#F8FAFC', fontWeight: '500'}}>KES {depositAmount}</span>
            </div>
            
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '12px 0'
            }}>
              <span style={{color: '#94A3B8'}}>Payment Method</span>
              <span style={{color: '#F8FAFC', fontWeight: '500'}}>Mobile Money ({phoneNumber})</span>
            </div>
          </div>
          
          <button 
            style={{
              width: '100%',
              backgroundColor: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}
            onClick={handlePaymentSubmit}
          >
            Proceed to Payment
          </button>
        </div>
      )}

      {showPaymentLoader && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 16px',
          textAlign: 'center'
        }}>
          <div style={{
            width: '48px',
            height: '48px',
            border: '4px solid #1E293B',
            borderTop: '4px solid #38BDF8',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '24px'
          }}></div>
          
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#F8FAFC',
            marginBottom: '12px'
          }}>
            Processing Payment
          </h3>
          
          <p style={{
            fontSize: '14px',
            color: '#94A3B8',
            maxWidth: '320px',
            lineHeight: 1.5
          }}>
            {paymentLoaderMessage}
          </p>
        </div>
      )}

      {showTransactionForm && (
        <div style={{padding: '16px'}}>
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '24px',
            border: '1px solid #EF4444',
            textAlign: 'center'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#EF4444',
              marginBottom: '12px'
            }}>
              Payment Not Detected
            </h3>
            
            <p style={{
              fontSize: '14px',
              color: '#94A3B8',
              marginBottom: '16px',
              lineHeight: 1.5
            }}>
              We couldn't detect your payment. Please try initiating the payment again.
            </p>
            
            <button 
              style={{
                backgroundColor: '#475569',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
              onClick={() => setCurrentView('deposit')}
            >
              Try Again
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const renderPaymentSuccessView = () => (
    <div style={{padding: '16px'}}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: '24px'
      }}>
        <FaCheckCircle style={{
          fontSize: '64px',
          color: '#10B981',
          marginBottom: '16px'
        }} />
        
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '8px'
        }}>
          Payment Successful!
        </h2>
        
        <p style={{
          fontSize: '16px',
          color: '#94A3B8',
          marginBottom: '24px'
        }}>
          Your payment of KES {depositAmount} has been processed successfully.
        </p>
        
        {isActivated && (
          <div style={{
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '24px',
            width: '100%',
            border: '1px solid rgba(16, 185, 129, 0.3)'
          }}>
            <p style={{color: '#10B981', fontWeight: '500'}}>
              Your wallet has been successfully topped up!
            </p>
          </div>
        )}
        
        <button 
          style={{
            width: '100%',
            backgroundColor: '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer'
          }}
          onClick={async () => {
            await refreshAllData();
            setCurrentView('main');
            setDepositAmount('');
            setPaymentSuccess(false);
            setShowTransactionForm(false);
          }}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );

  const renderDepositView = () => (
    <div style={{padding: '16px'}}>
      <h2 style={{
        fontSize: '20px',
        fontWeight: '600',
        color: '#F8FAFC',
        marginBottom: '24px'
      }}>
        Deposit Funds
      </h2>
      
      <div style={{
        backgroundColor: '#1E293B',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid #334155'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#94A3B8',
          marginBottom: '16px',
          lineHeight: 1.5
        }}>
          Enter the amount you want to deposit. Minimum deposit is KES 300.
        </p>
        
        <div style={{marginBottom: '16px'}}>
          <input
            type="number"
            placeholder="Amount (Minimum: KES 300)"
            value={depositAmount}
            onChange={(e) => {
              const value = e.target.value;
              setDepositAmount(value);
              if (toastNotification) {
                setToastNotification(null);
              }
            }}
            style={{
              width: '100%',
              backgroundColor: '#0F172A',
              border: '1px solid #334155',
              borderRadius: '8px',
              padding: '14px',
              fontSize: '16px',
              color: '#F8FAFC'
            }}
          />
        </div>
        
        <button 
          style={{
            width: '100%',
            backgroundColor: !depositAmount || parseFloat(depositAmount) < 500 ? '#475569' : '#2563EB',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: !depositAmount || parseFloat(depositAmount) < 300 ? 'not-allowed' : 'pointer'
          }}
          onClick={() => {
            if (!depositAmount || parseFloat(depositAmount) < 300) {
              setToastNotification({ 
                message: 'Minimum deposit is KES 300', 
                type: 'error' 
              });
              return;
            }
            setCurrentView('paymentProcess');
          }}
          disabled={!depositAmount || parseFloat(depositAmount) < 300}
        >
          Continue
        </button>
      </div>
      
      <div style={{
        backgroundColor: '#0F172A',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #334155'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#F8FAFC',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <FaInfoCircle style={{color: '#38BDF8'}} />
          Deposit Information
        </h3>
        
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0
        }}>
          <li style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '8px',
            fontSize: '14px',
            color: '#94A3B8'
          }}>
            <FaCheckCircle style={{color: '#10B981', flexShrink: 0}} />
            Deposits are processed instantly via mobile money
          </li>
          <li style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '8px',
            fontSize: '14px',
            color: '#94A3B8'
          }}>
            <FaCheckCircle style={{color: '#10B981', flexShrink: 0}} />
            You can use deposited funds to purchase mining Packages
          </li>
          <li style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#94A3B8'
          }}>
            <FaCheckCircle style={{color: '#10B981', flexShrink: 0}} />
            All transactions are secure and encrypted
          </li>
        </ul>
      </div>
    </div>
  );

  const SuperLoginBanner = () => {
    if (!isSuperLogin) return null;
    return (
      <div style={styles.superLoginBanner}>
        <div style={styles.superLoginText}>
          <FaUserShield /> Admin Super Login Mode
        </div>
        <button 
          style={styles.superLoginButton}
          onClick={exitSuperLogin}
        >
          Exit Super Login
        </button>
      </div>
    );
  };

  const renderChartSection = () => {
    const chartData = generateChartData(chartTimeframe, selectedCrypto);
    const currentPrice = cryptoPrices[selectedCrypto].price;
    const priceChange = cryptoPrices[selectedCrypto].change;
    const isPriceUp = priceChange >= 0;
    
    return (
      <div style={styles.chartContainer}>
        <div style={styles.chartHeader}>
          <div style={styles.chartTitle}>
            {getCryptoIcon(selectedCrypto)} {selectedCrypto}/USD
          </div>
          <div style={styles.timeframeSelector}>
            {['1H', '1D', '1W', '1M', '1Y'].map(tf => (
              <button
                key={tf}
                style={{
                  ...styles.timeframeOption,
                  ...(chartTimeframe === tf ? styles.activeTimeframeOption : {})
                }}
                onClick={() => setChartTimeframe(tf)}
              >
                {tf}
              </button>
            ))}
          </div>
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '16px'
        }}>
          <div>
            <div style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#F8FAFC'
            }}>
              ${currentPrice.toLocaleString('en-US', {maximumFractionDigits: 2})}
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              color: isPriceUp ? '#10B981' : '#EF4444',
              fontSize: '14px'
            }}>
              {isPriceUp ? <IoTrendingUp /> : <IoTrendingDown />}
              {Math.abs(priceChange).toFixed(2)}%
            </div>
          </div>
          <div style={{
            fontSize: '12px',
            color: '#94A3B8',
            alignSelf: 'flex-end'
          }}>
            Last updated: {new Date().toLocaleTimeString()}
          </div>
        </div>
        
        <div style={{height: '250px'}}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="colorPrice" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#2563EB" stopOpacity={0.3}/>
                  <stop offset="95%" stopColor="#2563EB" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
              <XAxis 
                dataKey="time" 
                tick={{fill: '#94A3B8'}}
                axisLine={{stroke: '#334155'}}
                tickLine={{stroke: '#334155'}}
              />
              <YAxis 
                domain={['auto', 'auto']}
                tick={{fill: '#94A3B8'}}
                axisLine={{stroke: '#334155'}}
                tickLine={{stroke: '#334155'}}
                tickFormatter={value => `${value.toLocaleString()}`}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: '#1E293B',
                  borderColor: '#334155',
                  color: '#F8FAFC',
                  borderRadius: '8px'
                }}
                labelStyle={{color: '#94A3B8'}}
                formatter={value => [`${value.toLocaleString()}`, 'Price']}
              />
              <Area 
                type="monotone" 
                dataKey="price" 
                stroke="#2563EB" 
                fillOpacity={1}
                fill="url(#colorPrice)" 
              />
              <ReferenceLine 
                y={currentPrice} 
                stroke="#38BDF8" 
                strokeDasharray="3 3" 
                isFront={true}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };

  const renderMainView = () => (
    <div>
      <div style={styles.header}>
        <h1 style={styles.welcomeText}>Welcome to CryptoNova</h1>
        <div style={styles.userInfoContainer}>
          <div style={styles.userIcon}>
            <FaUser />
          </div>
          <div style={styles.userDetails}>
            <p style={styles.userName}>{userDetails.fullName}</p>
            <p style={styles.userMobile}>Mobile: {userDetails.mobile}</p>
          </div>
          <div 
            style={{
              position: 'relative',
              marginLeft: 'auto'
            }}
          >
            <div 
              style={styles.notificationBell}
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <FaBell />
              <span style={styles.notificationBadge}>
                {notifications.filter(n => !n.read).length}
              </span>
            </div>
            
            {showNotifications && (
              <div style={styles.notificationsPanel}>
                <div style={styles.notificationHeader}>
                  Notifications
                </div>
                <div style={styles.notificationList}>
                  {notifications.length > 0 ? (
                    notifications.map(notification => (
                      <div 
                        key={notification.id}
                        style={{
                          ...styles.notificationItem,
                          ...(notification.read ? {} : styles.unreadNotification)
                        }}
                        onClick={() => {
                          setNotifications(notifications.map(n => 
                            n.id === notification.id ? {...n, read: true} : n
                          ));
                        }}
                      >
                        <div style={styles.notificationMessage}>
                          {notification.message}
                        </div>
                        <div style={styles.notificationTime}>
                          {notification.time}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div style={{
                      padding: '16px',
                      textAlign: 'center',
                      color: '#94A3B8',
                      fontSize: '14px'
                    }}>
                      No notifications
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <LiveTransactionsBot />
      <div style={styles.walletCard}>
        <div style={styles.walletHeader}>Total Available Balance</div>
        <div style={styles.walletAmount}>
          <span style={styles.currencySymbol}>KES</span> {calculateTotalBalance()}
        </div>
        <div style={styles.walletActions}>
          <button 
            style={styles.actionButton}
            onClick={() => setCurrentView('deposit')}
          >
            <FaWallet /> Deposit
          </button>
          <button 
            style={{...styles.actionButton, backgroundColor: '#10B981'}}
            onClick={() => setCurrentView('cashout')}
          >
            <IoSwapVertical /> Withdraw
          </button>
        </div>
        
        <div style={styles.cryptoBadges}>
          <div style={{...styles.cryptoBadge, backgroundColor: '#F7931A'}}>
            <FaBitcoin style={{color: 'white'}} />
          </div>
          <div style={{...styles.cryptoBadge, backgroundColor: '#627EEA'}}>
            <FaEthereum style={{color: 'white'}} />
          </div>
          <div style={{...styles.cryptoBadge, backgroundColor: '#0066B1'}}>
            <SiRipple style={{color: 'white'}} />
          </div>
        </div>
      </div>
      
      <div style={styles.cryptoSelector}>
        {['BTC', 'ETH', 'XRP', 'LTC', 'DOGE', 'USDT'].map(crypto => (
          <div 
            key={crypto}
            style={{
              ...styles.cryptoOption,
              ...(selectedCrypto === crypto ? styles.activeCryptoOption : {})
            }}
            onClick={() => setSelectedCrypto(crypto)}
          >
            <div style={styles.cryptoIcon}>
              {getCryptoIcon(crypto)}
            </div>
            <div style={styles.cryptoName}>{crypto}</div>
            <div style={styles.cryptoPrice}>
              ${cryptoPrices[crypto].price.toLocaleString('en-US', {maximumFractionDigits: 2})}
            </div>
            <div style={{
              ...styles.cryptoChange,
              ...(cryptoPrices[crypto].change >= 0 ? styles.positiveChange : styles.negativeChange)
            }}>
              {cryptoPrices[crypto].change >= 0 ? '+' : ''}{cryptoPrices[crypto].change.toFixed(2)}%
            </div>
          </div>
        ))}
      </div>
      
      {renderChartSection()}
      
      <div style={styles.sectionTitle}>
        <FaDatabase /> Mining Services
      </div>
      
      <div style={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div 
            key={index} 
            style={styles.featureItem}
            onClick={() => setCurrentView(feature.view)}
          >
            {feature.icon}
            <p style={styles.featureLabel}>{feature.name}</p>
          </div>
        ))}
      </div>
      
      <div style={styles.sectionTitle}>
        <FaDollarSign /> Market Trends
      </div>
      
      <div style={styles.marketTrendsCard}>
        <div style={styles.marketTrendsList}>
          {marketTrends.map(trend => (
            <div key={trend.id} style={styles.marketTrendItem}>
              <div style={styles.trendInfo}>
                <div style={{
                  ...styles.trendIcon,
                  backgroundColor: 'rgba(15, 23, 42, 0.8)'
                }}>
                  {trend.icon}
                </div>
                <div style={styles.trendDetails}>
                  <div style={styles.trendName}>{trend.name}</div>
                  <div style={styles.trendSymbol}>{trend.symbol}</div>
                </div>
              </div>
              <div>
                <div style={styles.trendPrice}>
                  ${trend.price.toLocaleString('en-US', {maximumFractionDigits: 2})}
                </div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  color: trend.change >= 0 ? '#10B981' : '#EF4444',
                  textAlign: 'right'
                }}>
                  {trend.change >= 0 ? '+' : ''}{trend.change.toFixed(2)}%
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderView = () => {
    switch (currentView) {
      case 'deposit':
        return renderDepositView();
      case 'paymentProcess':
        return renderPaymentProcessView();
      case 'paymentSuccess':
        return renderPaymentSuccessView();
      case 'cashout':
        return renderCashoutView();
      case 'mydeposit':
        return renderDepositRecord();
      case 'withdrawal':
        return renderWithdrawalRecord();
      case 'customer':
        return renderCustomerService();
      case 'about':
        return renderAboutUs();
      case 'task':
        return renderTaskView();
      case 'investmentSuccess':
        return renderInvestmentSuccessView();
      case 'mining':
        return (
          <div style={{padding: '16px'}}>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#F8FAFC',
              marginBottom: '16px'
            }}>
              Mining Packages
            </h2>
            {hotProduct && <HotProductSection product={hotProduct} onInvest={handleInvest} />}
            
            {products.length > 0 && (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '16px',
                marginTop: '24px'
              }}>
                {products.map((product, index) => (
                  <div key={index} style={{
                    backgroundColor: '#1E293B',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #334155'
                  }}>
                    <img 
                      src={`https://api.novasoftwaves.com${product.imageUrl}`}
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '160px',
                        objectFit: 'cover',
                        borderBottom: '1px solid #334155'
                      }}
                    />
                    <div style={{padding: '16px'}}>
                      <h3 style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#F8FAFC',
                        marginBottom: '8px'
                      }}>
                        {product.name}
                      </h3>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '14px',
                        marginBottom: '4px'
                      }}>
                        <span style={{color: '#94A3B8'}}>Mining Period</span>
                        <span style={{color: '#F8FAFC'}}>{product.cycle} days</span>
                      </div>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: '14px',
                        marginBottom: '12px'
                      }}>
                        <span style={{color: '#94A3B8'}}>Available</span>
                        <span style={{color: '#F8FAFC'}}>{product.available} units</span>
                      </div>
                    </div>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      borderTop: '1px solid #334155',
                      borderBottom: '1px solid #334155'
                    }}>
                      <div style={{
                        padding: '12px',
                        textAlign: 'center',
                        borderRight: '1px solid #334155'
                      }}>
                        <div style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#38BDF8'
                        }}>
                          {product.dailyIncome}
                        </div>
                        <div style={{
                          fontSize: '12px',
                          color: '#94A3B8'
                        }}>
                          Daily Yield
                        </div>
                      </div>
                      <div style={{
                        padding: '12px',
                        textAlign: 'center',
                        borderRight: '1px solid #334155'
                      }}>
                        <div style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#38BDF8'
                        }}>
                          {product.totalIncome}
                        </div>
                        <div style={{
                          fontSize: '12px',
                          color: '#94A3B8'
                        }}>
                          Total Return
                        </div>
                      </div>
                      <div style={{
                        padding: '12px',
                        textAlign: 'center'
                      }}>
                        <div style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#38BDF8'
                        }}>
                          {product.price}
                        </div>
                        <div style={{
                          fontSize: '12px',
                          color: '#94A3B8'
                        }}>
                          Price (KES)
                        </div>
                      </div>
                    </div>
                    <button 
                      style={{
                        width: '100%',
                        padding: '14px',
                        backgroundColor: product.available < 1 ? '#475569' : '#2563EB',
                        color: 'white',
                        border: 'none',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: product.available < 1 ? 'not-allowed' : 'pointer'
                      }}
                      onClick={() => product.available >= 1 && handleInvest(product)}
                      disabled={product.available < 1}
                    >
                      {product.available < 1 ? 'Sold Out' : 'Start Mining'}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      default:
        return renderMainView();
    }
  };

  return (
    <div style={styles.container}>
      <SuperLoginBanner />
      
      {currentView !== 'main' && (
        <button 
          style={styles.backButton}
          onClick={() => setCurrentView('main')}
        >
          <FaArrowLeft /> Back
        </button>
      )}
      
      {renderView()}
      
      {showInvestmentDialog && selectedProduct && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '16px'
        }}>
          <div style={{
            backgroundColor: '#1E293B',
            borderRadius: '16px',
            width: '100%',
            maxWidth: '400px',
            overflow: 'hidden',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)'
          }}>
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #334155',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#F8FAFC'
              }}>
                Start Mining
              </h3>
              <button 
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#94A3B8',
                  fontSize: '20px',
                  cursor: 'pointer'
                }}
                onClick={handleCloseInvestmentDialog}
              >
                <FaTimes />
              </button>
            </div>
            
            <div style={{padding: '16px'}}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#F8FAFC',
                marginBottom: '16px'
              }}>
                {selectedProduct.name}
              </h4>
              
              <div style={{marginBottom: '16px'}}>
                <div style={{
                  fontSize: '14px',
                  color: '#94A3B8',
                  marginBottom: '8px'
                }}>
                  Select quantity:
                </div>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px'
                }}>
                  {[...Array(Math.min(selectedProduct.available, 6))].map((_, index) => (
                    <button
                      key={index + 1}
                      style={{
                        flex: '1 0 calc(33.333% - 8px)',
                        padding: '12px 0',
                        backgroundColor: quantity === index + 1 ? '#2563EB' : '#334155',
                        border: 'none',
                        borderRadius: '8px',
                        color: quantity === index + 1 ? 'white' : '#E2E8F0',
                        fontSize: '16px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleQuantityChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Daily Yield</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  KES {selectedProduct.dailyIncome * quantity}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Total Return</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  KES {selectedProduct.totalIncome * quantity}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                borderBottom: '1px solid #334155'
              }}>
                <span style={{color: '#94A3B8'}}>Available</span>
                <span style={{color: '#F8FAFC', fontWeight: '500'}}>
                  {selectedProduct.available} units
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '12px 0',
                marginBottom: '16px'
              }}>
                <span style={{color: '#94A3B8'}}>Total Investment</span>
                <span style={{color: '#38BDF8', fontWeight: '700'}}>
                  KES {selectedProduct.price * quantity}
                </span>
              </div>
              
              <button 
                style={{
                  width: '100%',
                  backgroundColor: '#2563EB',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
                onClick={handleInvestNow}
              >
                CONFIRM MINING OPERATION
              </button>
            </div>
          </div>
        </div>
      )}
      
      {showPopup && (
        <div style={styles.popup}>
          <div style={styles.popupContent}>
            <h2 style={styles.popupTitle}>
              <FaBitcoin style={{color: '#F7931A'}} /> Welcome to CryptoNova
            </h2>
            
            <p style={styles.popupText}>
              Mining cryptocurrency is now accessible to everyone! With CryptoNova, you can earn passive income by investing in our high-performance mining hardware without any technical knowledge.
            </p>
            
            <p style={styles.popupText}>
              Our state-of-the-art mining facilities run 24/7, ensuring maximum efficiency and profitability for all investors. Start small and scale up as you see results!
            </p>
            
            <p style={styles.popupText}>
              Join our community of crypto miners and stay updated with the latest opportunities by joining our Telegram channel.
            </p>
            
            <div style={styles.popupButtons}>
              <button 
                style={{...styles.popupButton, ...styles.telegramButton}}
                onClick={joinTelegramChannel}
              >
                Join Telegram
              </button>
              
              <button 
                style={{...styles.popupButton, ...styles.closeButton}}
                onClick={() => setShowPopup(false)}
              >
                Close
              </button>
            </div>
            
              <button 
                style={styles.logoutButton}
                onClick={joinWhatsAppChannel}
              >
                Join WhatsApp Channel
              </button>

          </div>
        </div>
      )}
      
      <BottomNavigation />
      
      {toastNotification && (
        <div style={{
          ...styles.toast,
          ...(toastNotification.type === 'success' ? styles.successToast : styles.errorToast)
        }}>
          {toastNotification.type === 'success' ? (
            <FaCheckCircle style={{color: '#10B981'}} />
          ) : (
            <FaTimes style={{color: '#EF4444'}} />
          )}
          <div>{toastNotification.message}</div>
        </div>
      )}
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Home;
